import { render, staticRenderFns } from "./QuestionSet.vue?vue&type=template&id=1ba972b4"
import script from "./QuestionSet.vue?vue&type=script&lang=js"
export * from "./QuestionSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports